import { Col } from 'antd'
import FormItem from 'antd/es/form/FormItem'
import Select from 'components/Select'
import React from 'react'

import TotalCorporatesIcon from '../../../components/icons/TpoDashboardIcons/TotalCorporatesIcon'
import TotalEligbleIcon from '../../../components/icons/TpoDashboardIcons/TotalEligbleIcon'
import TotalPlacedIcon from '../../../components/icons/TpoDashboardIcons/TotalPlacedIcon'
import TotalRolesIcon from '../../../components/icons/TpoDashboardIcons/TotalRolesIcon'
import TotalStudentsIcon from '../../../components/icons/TpoDashboardIcons/TotalStudentsIcon'
import InfoCardsUpdate from '../../../components/InfoCardsUpdate'
import { ActionButton } from '../../JobPreview/style'
import {
  FilterLabel,
  JobRoleFlex,
  JobRoleWholeFlex,
  LeftSection,
  RightSection,
  SectionName,
} from '../../JobRoles/PageHeader/style'
import { labelChangeFunction } from './CommonFunction'
import {
  CardRow,
  HeaderSmallText,
  LeftSectionTPO,
  TopHeadingTPO,
} from './StyledComponent'
const currentYear = new Date().getFullYear()

const yearData = [
  { value: (currentYear - 1).toString(), label: (currentYear - 1).toString() }, // Previous year
  { value: currentYear.toString(), label: currentYear.toString() }, // Current year
  { value: (currentYear + 1).toString(), label: (currentYear + 1).toString() }, // Next year
]

const PageHeader = ({
  showHeader,
  state,
  cardsData,
  loading,
  handleChange,
  setIsExport,
  exportDisable,
}) => {
  const cardArr = [
    {
      key: 1,
      icon: <TotalStudentsIcon />,
      text: showHeader ? 'Total no. of Students' : 'Students',
      value: cardsData?.totalStudent || 0,
    },
    {
      key: 2,
      icon: <TotalCorporatesIcon />,
      text: showHeader ? 'Total Corporates' : ' Corporates',
      value: cardsData?.totalCorporates || 0,
    },
    {
      key: 3,
      icon: <TotalRolesIcon />,
      text: showHeader ? ' Total Roles Floated' : '  Roles Floated',
      value: cardsData?.totalRolesFloated || 0,
    },
    {
      key: 4,
      icon: <TotalPlacedIcon />,
      text: showHeader
        ? 'Total Students Placed'
        : state?.selectedCategory === 'PLACEMENT'
        ? ' Students Placed'
        : ' Students Selected',
      value: cardsData?.totalStudentsPlaced || 0,
    },
    {
      key: 5,
      icon: <TotalEligbleIcon />,
      text: showHeader
        ? ' Total Students Open for Placements'
        : `Open for ${ state?.selectedCategory ? labelChangeFunction(state?.selectedCategory, true) : 'Placements'}`,
      value: cardsData?.totalStudentsEligible || 0,
    },
  ]

  return (
    <div>
      <JobRoleWholeFlex>
        {showHeader ? (
          <>
            <JobRoleFlex>
              <LeftSection centerVertically>
                <SectionName column>
                  <TopHeadingTPO> Dashboard</TopHeadingTPO>
                </SectionName>
              </LeftSection>
              <RightSection centerVertically>
                <ActionButton
                  text={'Export'}
                  color="secondary"
                  onClick={() => {
                    setIsExport(true)
                  }}
                  disable={!exportDisable}
                />
              </RightSection>
            </JobRoleFlex>

            <LeftSectionTPO centerVertically>
              <HeaderSmallText>Placement data showing for</HeaderSmallText>

              <Col xs={4} style={{ display: 'flex' }}>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    alignItems: 'center',
                    gap: 10,
                    paddingTop: '3.5%',
                  }}
                >
                  <FilterLabel whiteSpace="pre">Passing Year</FilterLabel>
                  <FormItem style={{ width: '100%', marginBottom: '15px' }}>
                    <Select
                      options={yearData}
                      onChange={handleChange}
                      showSearch={true}
                      placeholder="Select Year"
                      valueParam="year"
                      nameParam="year"
                      colorstyle={true}
                      value={state?.placementDataYear}
                      listHeight={180}
                      boxShadow="rgba(123, 97, 255, 0.15) 0px 2px 6px 0px"
                    />
                  </FormItem>
                </div>
              </Col>
            </LeftSectionTPO>
          </>
        ) : null}
        <CardRow spaceBetween>
          {cardArr?.map(card => (
            <InfoCardsUpdate
              key={card?.key}
              width={'20em'}
              icon={card?.icon}
              text={card?.text}
              value={card?.value}
              background={showHeader}
              borderColor={showHeader}
              isSelected={showHeader}
              loading={loading}
            />
          ))}
        </CardRow>
      </JobRoleWholeFlex>
    </div>
  )
}

export default PageHeader
